<template>
    <div class="general-wrapper">
        <h1 class="header-title">Terms and Conditions</h1>
          <v-divider></v-divider>
        <div class="data-wrapper">
            <table v-for="item in sortedAboutContent" :key="item.id">
                    <tbody>
                        <div class="anchor" v-bind:id="item.shortcut"/>

                        <tr>
                            <td class="title">
                                {{item.name}}
                            </td>
                        </tr>
                        <tr>
                            <td class='time-stamp'>
                                Last updated: {{item.updated_at.seconds*1000|moment("MM-DD-YY")}}
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <div v-html="item.data"></div>
                            </td>
                        </tr>
                    </tbody>
                </table>
        </div>
    </div>
</template>

<script src="https://cdn.jsdelivr.net/lodash/4.13.1/lodash.js"></script>

<script>

import {mapGetters} from 'vuex'  

export default {

    name: "about",
     computed: {
            ...mapGetters([
                'getAboutContent',
            ]),
            sortedAboutContent: function () {
                return _.orderBy(this.getAboutContent, 'order')
            },
            mounted() {
                this.$ga.page('/about');
            }

        },
}
</script>

